import React from "react";
import { Link } from "react-router-dom";

import { withFirebase } from "../Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";

import classNames from "classnames";
import brand from "../../assets/img/brand.inverse.png";

import RichText from "../../components/RichText/RichText";

import './Footer.css';

class Footer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			year: new Date().getFullYear()
		};
	}
	
	componentDidMount() {
		// console.log('componentDidMount',this.props.auth)
	}
	
	componentDidUpdate() {
		// console.log('componentDidUpdate',this.props.auth)
		
	}
	
	footerClasses() {
		return classNames({
			"footer-primary": true
		});
	}
	
	render() {
		return (
			<section>
			<div className="footer-endorsements">
				<div className="container">
					<div className="content">
						{this.props.terms && <RichText content={this.props.terms.footer_sponsors} />}
						{/* <h2>Our Sponsors</h2>
						<p>Videos for Change would not be possible without some incredible organisations:</p>
						<img className="endorsements" src={endorsements} alt="Our Sponsors" /> */}
					</div>
				</div>
			</div>
			<footer className={this.footerClasses()}>
				<div className="container">

					<div className="copyright">
						<p>
							{/* <a href="https://twitter.com/highresolves" className="social-icon -twitter"  target="_blank">
								<svg viewBox="328 355 335 276"><path d="M 630, 425 A 195, 195 0 0 1 331, 600 A 142, 142 0 0 0 428, 570    A  70,  70 0 0 1 370, 523    A  70,  70 0 0 0 401, 521    A  70,  70 0 0 1 344, 455    A  70,  70 0 0 0 372, 460    A  70,  70 0 0 1 354, 370    A 195, 195 0 0 0 495, 442    A  67,  67 0 0 1 611, 380    A 117, 117 0 0 0 654, 363    A  65,  65 0 0 1 623, 401    A 117, 117 0 0 0 662, 390    A  65,  65 0 0 1 630, 425    Z"/></svg>
							</a> */}
							<a href="https://www.facebook.com/VideosforChange/" className="social-icon -facebook" target="_blank" rel="noopener noreferrer">
								<svg viewBox="0 0 512 512"><path d="M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"/></svg>
							</a>
							<a href="https://www.youtube.com/channel/UC4_JnyceUU7Q_Ezfz3PWGAQ"  className="social-icon -youtube" target="_blank" rel="noopener noreferrer">
								<svg viewBox="0 0 512 512"><path d="M422.6 193.6c-5.3-45.3-23.3-51.6-59-54 -50.8-3.5-164.3-3.5-215.1 0 -35.7 2.4-53.7 8.7-59 54 -4 33.6-4 91.1 0 124.8 5.3 45.3 23.3 51.6 59 54 50.9 3.5 164.3 3.5 215.1 0 35.7-2.4 53.7-8.7 59-54C426.6 284.8 426.6 227.3 422.6 193.6zM222.2 303.4v-94.6l90.7 47.3L222.2 303.4z"/></svg>
							</a>
							<a href="https://www.instagram.com/VideosForChange/"  className="social-icon -instagram" target="_blank" rel="noopener noreferrer">
								<svg viewBox="0 0 512 512"><path d="M256,69c60.9,0,68.1,0.2,92.2,1.3c22.2,1,34.3,4.7,42.4,7.9c10.6,4.1,18.2,9.1,26.2,17.1c8,8,12.9,15.6,17.1,26.2c3.1,8,6.8,20.1,7.9,42.4c1.1,24.1,1.3,31.3,1.3,92.2c0,60.9-0.2,68.1-1.3,92.2c-1,22.2-4.7,34.3-7.9,42.4c-4.1,10.6-9.1,18.2-17.1,26.2c-8,8-15.6,12.9-26.2,17.1c-8,3.1-20.1,6.8-42.4,7.9c-24.1,1.1-31.3,1.3-92.2,1.3c-60.9,0-68.1-0.2-92.2-1.3c-22.2-1-34.3-4.7-42.4-7.9c-10.6-4.1-18.2-9.1-26.2-17.1c-8-8-12.9-15.6-17.1-26.2c-3.1-8-6.8-20.1-7.9-42.4C69.2,324.1,69,316.9,69,256c0-60.9,0.2-68.1,1.3-92.2c1-22.2,4.7-34.3,7.9-42.4c4.1-10.6,9.1-18.2,17.1-26.2c8-8,15.6-12.9,26.2-17.1c8-3.1,20.1-6.8,42.4-7.9C187.9,69.2,195.1,69,256,69 M256,27.9c-62,0-69.7,0.3-94.1,1.4c-24.3,1.1-40.9,5-55.4,10.6c-15,5.8-27.7,13.6-40.4,26.3c-12.7,12.7-20.5,25.4-26.3,40.4c-5.6,14.5-9.5,31.1-10.6,55.4c-1.1,24.3-1.4,32.1-1.4,94.1c0,62,0.3,69.7,1.4,94.1c1.1,24.3,5,40.9,10.6,55.4c5.8,15,13.6,27.7,26.3,40.4c12.7,12.7,25.4,20.5,40.4,26.3c14.5,5.6,31.1,9.5,55.4,10.6c24.3,1.1,32.1,1.4,94.1,1.4c62,0,69.7-0.3,94.1-1.4c24.3-1.1,40.9-5,55.4-10.6c15-5.8,27.7-13.6,40.4-26.3c12.7-12.7,20.5-25.4,26.3-40.4c5.6-14.5,9.5-31.1,10.6-55.4c1.1-24.3,1.4-32.1,1.4-94.1c0-62-0.3-69.7-1.4-94.1c-1.1-24.3-5-40.9-10.6-55.4c-5.8-15-13.6-27.7-26.3-40.4c-12.7-12.7-25.4-20.5-40.4-26.3c-14.5-5.6-31.1-9.5-55.4-10.6C325.7,28.1,318,27.9,256,27.9"/><path d="M256,138.8c-64.7,0-117.2,52.5-117.2,117.2c0,64.7,52.5,117.2,117.2,117.2c64.7,0,117.2-52.4,117.2-117.2C373.2,191.3,320.7,138.8,256,138.8 M256,332c-42,0-76-34-76-76c0-42,34-76,76-76c42,0,76,34,76,76C332,298,298,332,256,332"/><path d="M405.2,134.2c0,15.1-12.3,27.4-27.4,27.4c-15.1,0-27.4-12.3-27.4-27.4c0-15.1,12.3-27.4,27.4-27.4C392.9,106.8,405.2,119.1,405.2,134.2"/></svg>
							</a>
						</p>
						<p>
							<a href="mailto:vfc@highresolves.org">Contact Us</a> 
							<Link to="/page/privacy">Privacy Policy</Link>
						</p>
						<p>Copyright &copy; High Resolves {this.state.year}</p>
						<p style={{display:"none"}}>{process.env.NODE_ENV}</p>
					</div>
					<div className="brand">
						<img src={brand} alt="Videos for Change" />
					</div>
				</div>
			</footer>
			</section>
		);
	}
}
export default withPrismic(withFirebase(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js